import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

interface GTMProps {
  gtmId: string;
}

const useGtmId = () => process.env.GATSBY_GTM_ID || "";

const GTM: React.FC<GTMProps> = ({ gtmId }) => {
  useEffect(() => {
    ((w, d, s, l, i) => {
      // eslint-disable-next-line no-param-reassign
      w[l] = w[l] || [];
      w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s) as HTMLScriptElement;
      const dl = l !== "dataLayer" ? `&l=${l}` : "";
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      if (f.parentNode) {
        f.parentNode.insertBefore(j, f);
      }
    })(window, document, "script", "dataLayer", gtmId);
  }, [gtmId]);

  return (
    <Helmet>
      <noscript id="google-tag-manager-noscript">
        {`
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="gtm"
          />
        `}
      </noscript>
    </Helmet>
  );
};

export const SEO = () => {
  const gtmId = useGtmId();
  return <>{gtmId && <GTM gtmId={gtmId} />}</>;
};
